import React from 'react';
import { BgImage } from '../components/Img';
import { IMG } from '../images';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div>
      {/* Hero Section */}
      <section 
        className="hero" 
        style={{
          minHeight: '40vh'
        }}
      >
        <BgImage image={IMG.facade} position="50% 40%" priority />
        <div className="hero-content">
          <h1>Privacy Policy</h1>
          <p>How we protect and handle your personal information</p>
        </div>
      </section>

      {/* Content */}
      <section className="section">
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            
            <p style={{ fontSize: '1.2rem', marginBottom: '2rem', lineHeight: 1.8 }}>
              At ProClimb Solutions, we are committed to protecting your privacy and handling personal information in accordance with the Australian Privacy Principles under the Privacy Act 1988 (Cth).
            </p>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>Information We Collect</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>We may collect the following information when you interact with our website or services:</p>
              <ul style={{ marginLeft: '2rem', marginBottom: '1rem', lineHeight: 1.8 }}>
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Company or building name</li>
                <li>Property location</li>
                <li>Service request details</li>
              </ul>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>This information may be collected through:</p>
              <ul style={{ marginLeft: '2rem', lineHeight: 1.8 }}>
                <li>Contact forms</li>
                <li>Quote requests</li>
                <li>Email communications</li>
                <li>Phone conversations</li>
                <li>Website analytics</li>
              </ul>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>How We Use Your Information</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>We collect personal information to:</p>
              <ul style={{ marginLeft: '2rem', marginBottom: '1rem', lineHeight: 1.8 }}>
                <li>Respond to enquiries and quote requests</li>
                <li>Provide rope access services</li>
                <li>Improve our website and services</li>
                <li>Communicate with clients regarding projects</li>
                <li>Meet legal and regulatory requirements</li>
              </ul>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8, fontWeight: 600 }}>
                We will not sell or rent your personal information to third parties.
              </p>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>Third-Party Services</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>Our website may use trusted third-party tools such as:</p>
              <ul style={{ marginLeft: '2rem', marginBottom: '1rem', lineHeight: 1.8 }}>
                <li>Website analytics</li>
                <li>Hosting services</li>
                <li>Email systems</li>
              </ul>
              <p style={{ lineHeight: 1.8 }}>These providers may collect anonymous data for performance and security purposes.</p>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>Data Security</h2>
              <p style={{ lineHeight: 1.8 }}>
                We take reasonable steps to protect personal information from misuse, loss, unauthorised access or disclosure.
              </p>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>Access and Correction</h2>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>
                You may request access to the personal information we hold about you and request corrections if necessary.
              </p>
              <p style={{ marginBottom: '1rem', lineHeight: 1.8 }}>To do so, contact us at:</p>
              <div style={{ background: 'var(--light-gray)', padding: '1.5rem', border: '1px solid var(--border-color)', marginTop: '1rem' }}>
                <p style={{ marginBottom: '0.5rem' }}><strong>Email:</strong> <a href="mailto:info@proclimbsolutions.com.au" style={{ color: 'var(--safety-orange)' }}>info@proclimbsolutions.com.au</a></p>
                <p><strong>Phone:</strong> <a href="tel:0426920301" style={{ color: 'var(--safety-orange)' }}>0426 920 301</a></p>
              </div>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ color: 'var(--navy-blue)', marginBottom: '1.5rem', fontSize: '2rem' }}>Changes to This Policy</h2>
              <p style={{ lineHeight: 1.8 }}>
                This Privacy Policy may be updated from time to time to reflect changes in legal requirements or business practices.
              </p>
            </div>

            <div style={{ background: 'var(--light-gray)', padding: '2rem', border: '1px solid var(--border-color)', marginTop: '3rem' }}>
              <p style={{ marginBottom: '1rem' }}>Last Updated: January 2025</p>
              <p>For questions about this Privacy Policy, please contact us at <a href="mailto:info@proclimbsolutions.com.au" style={{ color: 'var(--safety-orange)' }}>info@proclimbsolutions.com.au</a></p>
            </div>

            <div style={{ textAlign: 'center', marginTop: '3rem' }}>
              <Link to="/contact" className="btn-primary">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
